import { DmsClientTheme } from "./dms-client-theme";
import { LpmConfig } from "./lpm.config";

export class ExternalUser {
   id: string = null;
   userId: string = null;
   firstName: string = null;
   lastName: string = null;
   name: string = null;
   email: string = null;
   lpmReference: string = null;
}

export class WebComponentInputParams {
   defaultView:'explorer' | 'labels' | 'recent' | 'starred' | 'trash' | 'shared' | 'copilot-settings' | 'upload' = 'explorer';
   folderId: string = null;
   userId: string = null;
   externalUsers: ExternalUser[] = [];
   lpmConfig: LpmConfig = new LpmConfig();
   clientTheme:DmsClientTheme = new DmsClientTheme();
}